import { getParameterByName } from './getParameterByName';

/**
 * Checks if the teacher_preview parameter is present in the current URL
 * @param url - Optional URL to check (defaults to window.location.href)
 * @returns true if teacher_preview parameter exists, false otherwise
 */
export function hasTeacherPreview(url?: string): boolean {
  const value = getParameterByName('teacher_preview', url, null);
  return value === 'true';
}
